import React from "react";

// Estados del mensaje (detalle) y del lote (cabecera). Ver sk-medical-back/docs/MOTOR_ENVIOS.md.
export const ESTADOS_MENSAJE = {
    pendiente: { label: "Pendiente", color: "secondary", icon: "bi-hourglass-split" },
    procesando: { label: "Procesando", color: "info", icon: "bi-arrow-repeat" },
    enviado: { label: "Enviado", color: "primary", icon: "bi-send" },
    entregado: { label: "Entregado", color: "success", icon: "bi-check2" },
    leido: { label: "Leído", color: "success", icon: "bi-check2-all" },
    error: { label: "Reintentando", color: "warning", icon: "bi-exclamation-triangle" },
    fallido: { label: "Fallido", color: "danger", icon: "bi-x-circle" },
    cancelado: { label: "Cancelado", color: "dark", icon: "bi-slash-circle" },
};

export const ESTADOS_LOTE = {
    pendiente: { label: "Pendiente", color: "secondary", icon: "bi-hourglass-split" },
    en_proceso: { label: "En proceso", color: "info", icon: "bi-arrow-repeat" },
    completado: { label: "Completado", color: "success", icon: "bi-check-circle" },
    completado_con_errores: { label: "Con errores", color: "warning", icon: "bi-exclamation-circle" },
    cancelado: { label: "Cancelado", color: "dark", icon: "bi-slash-circle" },
};

export const ORIGENES = {
    honorarios_adelanto: "Honorarios adelanto",
    honorarios_fm: "Honorarios fin de mes",
    cobranza: "Cobranza",
    facturas: "Facturas",
    manual: "Manual",
    sistema: "Sistema",
    prueba: "Prueba",
};

export const ESTADOS_LOTE_ABIERTOS = ["pendiente", "en_proceso"];

export const BadgeEstado = ({ estado, tipo = "mensaje" }) => {
    const def = (tipo === "lote" ? ESTADOS_LOTE : ESTADOS_MENSAJE)[estado] || { label: estado, color: "light", icon: "bi-question" };
    const texto = def.color === "warning" || def.color === "light" ? "text-dark" : "";
    return (
        <span className={`badge bg-${def.color} ${texto}`}>
            <i className={`bi ${def.icon} me-1`}></i>
            {def.label}
        </span>
    );
};

/** Barra apilada: enviados (azul) + fallidos (rojo) + cancelados (gris) sobre el total. */
export const BarraAvance = ({ lote }) => {
    const total = Number(lote.total) || 0;
    const pct = (n) => (total ? (Number(n) / total) * 100 : 0);
    const terminados = Number(lote.enviados) + Number(lote.fallidos) + Number(lote.cancelados);
    return (
        <div style={{ minWidth: 160 }}>
            <div className="progress" style={{ height: 10 }}>
                <div className="progress-bar bg-primary" style={{ width: `${pct(lote.enviados)}%` }} title={`${lote.enviados} enviados`}></div>
                <div className="progress-bar bg-danger" style={{ width: `${pct(lote.fallidos)}%` }} title={`${lote.fallidos} fallidos`}></div>
                <div className="progress-bar bg-secondary" style={{ width: `${pct(lote.cancelados)}%` }} title={`${lote.cancelados} cancelados`}></div>
            </div>
            <small className="text-muted">{terminados}/{total}</small>
        </div>
    );
};

export const IconoCanal = ({ tipo }) =>
    tipo === "whatsapp"
        ? <i className="bi bi-whatsapp text-success" title="WhatsApp"></i>
        : <i className="bi bi-envelope text-primary" title="Correo"></i>;

export const mensajeError = (error, porDefecto) => error?.response?.data?.message || porDefecto;

/** "2026-10-20 17:49:25" → "20-10-2026 17:49". */
export const fechaHora = (valor) => {
    if (!valor) return "—";
    const [fecha, hora = ""] = String(valor).split(" ");
    const [a, m, d] = fecha.split("-");
    return `${d}-${m}-${a} ${hora.slice(0, 5)}`;
};

/** Minutos transcurridos desde una fecha "YYYY-MM-DD HH:MM:SS" (hora local del navegador). */
export const minutosDesde = (valor) => {
    if (!valor) return null;
    const fecha = new Date(String(valor).replace(" ", "T"));
    if (isNaN(fecha.getTime())) return null;
    return Math.max(0, Math.round((Date.now() - fecha.getTime()) / 60000));
};

export const haceCuanto = (valor) => {
    const min = minutosDesde(valor);
    if (min === null) return "";
    if (min < 1) return "hace menos de 1 min";
    if (min < 60) return `hace ${min} min`;
    const horas = Math.floor(min / 60);
    if (horas < 24) return `hace ${horas} h`;
    return `hace ${Math.floor(horas / 24)} días`;
};
